import React from "react";

export default function ContextDrawer({ open, title, subtitle, size = "medium", children, onClose }) {

	const getWidthForSize = () => {
	  if (size === "small") return 320;
	  if (size === "large") return 1000;
	  return 360; // medium default
	};
	
	const width = getWidthForSize();

	const drawerStyle = {
	  position: "fixed",
	  top: "40px",
	  right: open ? "460px" : `-${width}px`,
	  width: `${width}px`,
	  bottom: "40px",
	  background: "#ffffff",
	  boxShadow: "-10px 0 24px rgba(0,0,0,0.12)",
	  transition: "right 0.4s cubic-bezier(0.25,0.8,0.25,1)",
	  zIndex: 250,
	  display: "flex",
	  flexDirection: "column",
	  borderTopLeftRadius: "18px",
	  borderBottomLeftRadius: "18px",
	  overflow: "hidden",
	  pointerEvents: open ? "auto" : "none"
	};


  const headerStyle = {
    padding: "22px 24px",
    borderBottom: "1px solid #eee",
    background: "linear-gradient(180deg, #f7f8fa 0%, #ffffff 100%)",
    position: "relative"
  };

  return (
    <div style={drawerStyle}>
      <div style={headerStyle}>
        <div style={{ position: "absolute", top: 18, right: 18, cursor: "pointer" }} onClick={onClose}>
          ✕
        </div>
        <div style={{ fontSize: 18, fontWeight: 600 }}>{title}</div>
        {subtitle && <div style={{ fontSize: 12, color: "#777" }}>{subtitle}</div>}
      </div>

      <div style={{
        flex: 1,
        padding: "18px 20px",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "14px"
      }}>
        {children}
      </div>
    </div>
  );
}
